// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import {
  getAccessToken as getStoredAccessToken,
  getToken as getStoredToken,
  clearAllTokens,
} from '../utils/storageUtils';
import { authContextRef } from './authContextRef';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(getStoredAccessToken() || null);
  const [token, setToken] = useState(getStoredToken() || '');

  const login = useCallback((newAccessToken, newToken) => {
    setAccessToken(newAccessToken);
    setToken(newToken);
  }, []);

  const logout = useCallback(() => {
    setAccessToken(null);
    setToken('');
    clearAllTokens();
  }, []);

  // Connect the logout to ref, so axios can call it
  useEffect(() => {
    authContextRef.current = { logout, accessToken, token, login };
  }, [logout, accessToken, token, login]);

  return (
    <AuthContext.Provider
      value={{
        accessToken,
        token,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Hook for components to use the AuthContext
export const useAuth = () => useContext(AuthContext);
